import type { ReactNode } from "react";
import "./BottomRow.scss";
import classNames from "classnames";
import GoToSettings from "@/pages/human-resources/time-management/components/schedule-palette/bottom-row/go-to-settings/GoToSettings.tsx";
import type { Page } from "@/shared/model/pages-management/ApplicationPages.ts";

interface Properties {
  horizontal: boolean;
  settingsPage: Page;
}

export default function BottomRow(props: Properties): ReactNode {
  return (
    <div className={classNames("bottom-row", props.horizontal && "horizontal")}>
      <GoToSettings targetPage={props.settingsPage} />
    </div>
  );
}
